export default {
      id: "export-usage",
      viewBox: "0 0 450 450",
      url: __webpack_public_path__ + "img/icons.a13474e0.svg#export",
      toString: function () {
        return this.url;
      }
    }